export const imageCodes = {
    
    catego: {
        code: "${merchantId}_tmpl_img_2",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fp.png?alt=media&token=b8788225-3b93-4fcf-b671-c5420c86db9a"
    },
    catego1: {
        code: "${merchantId}_tmpl_img_3",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcat.png?alt=media&token=346ddbfb-b9da-4671-b99c-995e91ad0c53"
    },
    catego2: {
        code: "${merchantId}_tmpl_img_4",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcat2.png?alt=media&token=c6b3c53e-a1f9-4562-8122-16e9e243a17e"
    },
    catego3: {
        code: "${merchantId}_tmpl_img_5",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcat3.png?alt=media&token=67d410ec-c2d1-44e7-85da-d637ab8a1669"
    },
    catego4: {
        code: "${merchantId}_tmpl_img_6",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcat4.png?alt=media&token=7a6a0519-0ece-47eb-8bba-91fe31772bc2"
    },
    hero: {
        code: "${merchantId}_tmpl_img_7",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F324237962_443294931256688_7203159878585957054_n.jpg?alt=media&token=f8f6c8d6-f4b3-42d0-a8dc-579c9d5e690d"
    },
    product: {
        code: "${merchantId}_tmpl_img_8",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fp1.png?alt=media&token=9ab55a5b-9e0b-4ae0-9f23-f64fca824054"
    },
    product1: {
        code: "${merchantId}_tmpl_img_9",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fp2.png?alt=media&token=54cfc5c3-901c-4c15-8a2b-85bd0e564436"
    },
    product2: {
        code: "${merchantId}_tmpl_img_10",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fp3.png?alt=media&token=7d15a2f6-fa4c-4cde-a6f0-80d520199000"
    },
    besSel: {
        code: "${merchantId}_tmpl_img_11",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fbs.png?alt=media&token=a9ae7949-631a-4fc1-97cd-79bb86a29fc2"
    },
    besSel1: {
        code: "${merchantId}_tmpl_img_12",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fbs1.png?alt=media&token=de1ea858-74e8-4110-96bf-75e2f63eb848"
    },
    besSel2: {
        code: "${merchantId}_tmpl_img_13",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fbs2.png?alt=media&token=1d7396be-edfa-4507-ae67-b34114c6c072"
    },
    memberPhoto: {
        code: "${merchantId}_tmpl_img_16",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fc.png?alt=media&token=b832dfec-1349-46a9-aed7-6c59d32f99bc"
    },
}


export const textCodes = {
    text: {
        code: "${merchantId}_tmpl_text_1",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nulla quis repellat natus rem tempora itaque, vero eaque delectus voluptas minus aliquid sit ab maxime ea quisquam, dolores consectetur aspernatur repellendus!"
    },

    Join1: {
        code: "${merchantId}_tmpl_text_2",
        text: "Join Our"
    },
    loyaltyDesHome: {
        code: "${merchantId}_tmpl_text_3",
        text: "BOND Product များကို အလွယ်တကူဝယ်ယူနိုင်ဖို့ App လေး လုပ်ပေးထားပါတယ်ခင်ဗျာ"
    },
    
    earnPointsHome: {
        code: "${merchantId}_tmpl_text_49",
        text: "—— Earn Points"
    },
}

export const titleCodes = {
    About: {
        code: "${merchantId}_tmpl_title_1",
        title: "About"
    },
    memberHome: {
        code: "${merchantId}_tmpl_title_2",
        title: "Digital Membership"
    },
    
}